#import "./SentenceGroupMelodyDetails.graphql"
query SentenceGroupMelodiesQuery {
  sentenceGroupMelodies {
    ...sentenceGroupMelodyDetails
  }
}
